import store from '@/store'
const setNotification = 'setNotification'

const notificationActions = {
  success (message) {
    store.commit(setNotification, { message, type: 'success', timeout: 5000 })
  },
  danger (message) {
    store.commit(setNotification, { message, type: 'danger', timeout: 5000 })
  },
  info (message) {
    store.commit(setNotification, { message, type: 'info', timeout: 5000 })
  }
}

var notificationPlugin = {
  install: function (Vue, options) {
    Vue.prototype.$notify = notificationActions
  },
  notificationActions
}

export default notificationPlugin



// WEBPACK FOOTER //
// ./src/plugin/notificationPlugin.js